import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import style from "@styles/pages/flow/boxes/Box.module.scss";
import { memo } from "react";
import ActionBaseBox from "../layout/ActionBaseBox";

export default memo(({ id, data, selected, isConnectable }) => {
  const subline = () => {
    const str = FlowBox.getSublineByType(BoxTypes.ExportAudienceOutput, data);
    return str ? <div className={style.subline}>{str}</div> : null;
  };

  return (
    <ActionBaseBox
      id={id}
      selected={selected}
      valid={BoxValidations.validate(BoxTypes.ExportAudienceOutput, data)}
      title={BoxTitles.ExportAudienceOutput}
      isConnectable={isConnectable}
    >
      {subline()}
    </ActionBaseBox>
  );
});
